<template>
    <ModalComponent 
        :name="'error-copiar-invitaciones'"
        :title="'Asientos ya ocupados'"
        v-on:close="() => close()"
    >
        <p>Los siguientes pedidos no han podido volver a generarse por que los asientos estaban ya ocupados:</p>
        <ul>
            <li v-for="pedido in errors" v-bind:key="pedido.id">
                <span>{{ pedido.id }} - {{ pedido.entradas.length > 0 ? pedido.entradas[0].concept : '' }}</span>
            </li>
        </ul>

    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['sesion', 'errors'],
        methods: {
            close() {
                this.$emit('close', 'error-copiar-invitaciones');
            },
        },
        components: { ModalComponent }
    }
</script>
